// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.
export const importSmartCreationWrapper = (): Promise<typeof import('./index')> =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant/smart-creation-wrapper" */ './index'
	);
